exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-cell[data-v-2b9403f4]::after {\r\n    position: absolute;\r\n    box-sizing: border-box;\r\n    content: ' ';\r\n    pointer-events: none;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0.42667rem;\r\n    border-bottom: 0.02667rem solid #ebedf0;\r\n    -webkit-transform: scaleY(.5);\r\n    transform: scaleY(.5);\n}\r\n\r\n", ""]);

// exports
